module.exports = __webpack_public_path__ + "static/media/recruit_sp.d4de3f85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/recruit_sp.jpg
// module id = 492
// module chunks = 0